/**
 * Applies the given entity-to-GraphQL transformer to a Relay page of entities.
 * @typeParam E - Entity type passed into the transformer
 * @typeParam G - GraphQL type output by the transformer
 * @param page -  Page of Relay results from a database query
 * @param transformer - transformer which accepts E and returns G
 */
export async function mapRelayPage<Entity, TransformedEntity, PageInfo>(
  page: {
    edges: { cursor: string; node: Entity }[];
    pageInfo: PageInfo;
  },
  transformer: (
    entity: Entity
  ) => TransformedEntity | Promise<TransformedEntity>
): Promise<{
  pageInfo: PageInfo;
  edges: {
    cursor: string;
    node: TransformedEntity;
  }[];
}> {
  return {
    pageInfo: page.pageInfo,
    edges: await Promise.all(
      page.edges.map(async (edge) => ({
        cursor: edge.cursor,
        node: await transformer(edge.node),
      }))
    ),
  };
}
